// extracted by mini-css-extract-plugin
export default {"main":"main__i1bdwYnF","title":"title__CsMohhgN"};